module.exports = __webpack_public_path__ + "images/facility/facility-page/unit--parking-300sqft.svg";